import './App.css';

import React from 'react';
import { Switch } from 'react-router-dom';
import { authenticatedRoute, publicRoutes } from './router';
import AuthMiddleware from './router/route';
import Layout from './components/layout';
import PublicLayout from './components/publiclayout';

function App() {
  return (
    <React.Fragment>
      
        <Switch>
          {publicRoutes.map((route,id) => (
            <AuthMiddleware
              path={route.path}
              Component={route.component}
              key={id}
              exact
              isAuthenticatedRoute={false}
              Layout={PublicLayout}
            />
          ))}

          {authenticatedRoute.map((route,id) => (
            <AuthMiddleware
              path={route.path}
              Component={route.component}
              key={id}
              exact
              isAuthenticatedRoute={true}
              Layout={Layout}
            />
          ))}
        </Switch>

    </React.Fragment>
  );
}

export default App;
